module.exports = __webpack_public_path__ + "img/icon-bag.aade0840.svg";